import { useCostPriceStore } from '../../stores/appCostPriceStore';
import { useCostPriceCategoriesStore } from '../../stores/appCostPriceCategoriesStore';
import { useFiltersStore } from '../../stores/appFiltersStore';
import { filterRevenueByRestaurantSections } from '../revenuehistory/utils';
import { aggregateRevenueItemsByCategory, calculateTotalRevenue, calculateRevenueMix } from '../../utils/revenueHistoryCalculations';
import { formatEuro, formatPct, readTourSnapshot, sideLabel } from './tourValues';

/** Describe the selected timeframe, without comparing a partial period to a full one. */
export function getRevenuePerformanceValues(): Record<string, string> {
  const snapshot = readTourSnapshot('revenue');
  const total = calculateTotalRevenue(snapshot.revenue, snapshot.showExVatRevenue);
  if (total === 0) return { context: '' };
  const amount = formatEuro(total);
  const mix = calculateRevenueMix(snapshot.revenue, snapshot.showExVatRevenue);
  if (mix.food.value <= 0 || mix.drinks.value <= 0 || mix.food.value === mix.drinks.value) {
    return { context: 'amount', amount };
  }
  const foodLeads = mix.food.value > mix.drinks.value;
  return {
    context: 'mix', amount,
    leader: sideLabel(foodLeads ? 'food' : 'drinks'),
    other: sideLabel(foodLeads ? 'drinks' : 'food'),
  };
}

/** Use the same category aggregation and section scope as the items table. */
export function getRevenueCategoryValues(): Record<string, string> {
  const snapshot = readTourSnapshot('revenue');
  const revenue = filterRevenueByRestaurantSections(snapshot.revenue, useFiltersStore.getState().sectionFilters);
  const categories = aggregateRevenueItemsByCategory(
    revenue, snapshot.showExVatRevenue,
    useCostPriceStore.getState().costPriceList,
    useCostPriceCategoriesStore.getState().categories,
    calculateTotalRevenue(revenue, snapshot.showExVatRevenue),
  ).filter(category => category.totalRevenue > 0).slice(0, 3);
  return categories.length ? {
    context: 'breakdown',
    breakdown: categories.map(category => `${category.categoryName}: ${formatPct(category.percentageOfTotal)}`).join(', '),
  } : { context: '' };
}
